import { MovieTileProps } from './types'
import type { MediaEntry, MediaType } from './api-types'

/**
 * Map a medialib {@link MediaEntry} to the {@link MovieTileProps} a `MovieTile`
 * renders — the single shared version of a mapper that browse, news and the
 * favorites/watch-later lists used to each keep (and quietly drift) their own copy
 * of. `media_type` is passed explicitly because some endpoints carry it per item
 * and others (browse showcases) only at the row level.
 */
export const createMovieTileProps = (
  entry: MediaEntry,
  media_type: MediaType = entry.media_type ?? 'movie'
): MovieTileProps => ({
  media_type,
  movieId: entry.id,
  title: entry.name || entry.original_title || entry.original_name || '',
  score: entry.vote_average ?? '',
  // The tile shows one synopsis; the API sends the copy as `description` and leaves
  // `overview` empty on much of the catalog, which left the hover plot blank.
  overview: entry.overview || entry.description || '',
  backdrop: entry.backdrop_path?.href ?? '',
  progress: entry.player?.in_progress ? Object.values(entry.player?.position || {}).pop()?.percentage : undefined,
})
